import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { FEATURE_CONFIG, featureConfigFactory, FeatureConfigInitializer } from './feature-toggles.config';
import { initialize } from './toggle-point/toggle-point-function-helper';
import { TogglePointDirective } from './toggle-point/toggle-point.directive';
import { FeatureConfig, ToggleRouterService } from './toggle-router.service';

const imports = [TogglePointDirective];
const exports = [TogglePointDirective];
const providers = [
  ToggleRouterService,
  { provide: APP_INITIALIZER, deps: [ToggleRouterService], useFactory: initialize, multi: true },
];

@NgModule({ imports, exports })
export class FeatureTogglesModule {
  /**
   * Import the module using this static method to import the providers.
   * This must be imported on the core module of the project.
   *
   * @param featureConfig Experimental features configuration
   */
  static forRoot(featureConfig?: FeatureConfig): ModuleWithProviders<FeatureTogglesModule> {
    return {
      ngModule: FeatureTogglesModule,
      providers: [{ provide: FEATURE_CONFIG, useValue: featureConfig }, ...providers],
    };
  }

  /**
   * Import the module using this static method to import the providers.
   * This must be imported on the core module of the project.
   *
   * @param featureConfigInitializer function that should return an observable
   *        to get the experimental features configuration
   */
  static forRootAsync(featureConfigInitializer?: FeatureConfigInitializer): ModuleWithProviders<FeatureTogglesModule> {
    return {
      ngModule: FeatureTogglesModule,
      providers: [
        { provide: FEATURE_CONFIG, useFactory: featureConfigFactory.bind(null, featureConfigInitializer) },
        ...providers,
      ],
    };
  }
}
